<template>
    <div class="footer">
        <div class="content">
            <div class="content-item" @click="gohome" style="cursor: pointer;">
                <div><img class="img1" src="@/assets/footer/logo.png" alt=""></div>
                <div>
                    <p class="p1">企业生态</p>
                    <p class="p2">数字货运</p>
                    <p class="p2">解决方案</p>
                    <p class="p2">产品介绍</p>
                    <p class="p2">排队方案</p>
                </div>
                <div>
                    <p class="p1">新闻中心</p>
                    <p class="p2">企业动态</p>
                    <p class="p2">媒体报道</p>
                    <p class="p2">行业观察</p>
                </div>
                <div>
                    <p class="p1">关于我们</p>
                    <p class="p2">企业介绍</p>
                    <p class="p2">社会责任</p>
                    <p class="p2">党群建设</p>
                    <p class="p2">企业文化</p>
                    <p class="p2">加入我们</p>
                </div>

            </div>
            <div class="xieyi">
                <span style="margin-right: 20px;">Copyright © www.yttx.com</span>
                <a href="http://beian.miit.gov.cn/" class="footer_font">蒙ICP备19001876号</a>
                <span style=" margin-right: 20px;">中网慧通网络科技有限公司智慧货场</span>
                <span style="cursor: pointer;margin-right: 20px;" @click="clickHandle">用户协议</span>
                <span style="cursor: pointer;" @click="clickHandle2"> 隐私协议</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        clickHandle() {
            this.$router.push('/userAgreement')
        },
        clickHandle2() {
            this.$router.push('/privacy')
        },
        gohome() {
            if (this.$route.path == '/') {

                this.$parent.gotop()
            } else {
                this.$router.push('/')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: start;
    background: #282828;

    .content {
        width: 850px;
        // margin: auto;
        padding-top: 40px;

        .img1 {
            width: 168px;
            height: 40px;
        }

        &-item {
            display: flex;
            justify-content: space-between;

            .p1 {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #AAAAAA;
                margin-bottom: 50px;
            }

            .p2 {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                margin-bottom: 30px;
            }

            .p3 {
                font-size: 38px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                margin-bottom: 60px;
            }

            .img2 {
                width: 185px;
                height: 185px;
                margin-bottom: 37px;
            }

            .p4 {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
            }
        }
    }

    .xieyi {
        display: flex;
        justify-content: center;
        color: #FFFFFF;
        margin-top: 20px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-bottom: 20px;

        .footer_font {
            color: #fff;
            margin-right: 20px;
        }
    }
}</style>